import { createSelector } from 'reselect';
import { getIsMESEnabled } from './getIsMESEnabled';
import { getMachineSettings } from './getMachineSettings';
import { getAssociatedErpResourceIds } from './getApiErpResources';

/**
 * MES-aware resource list for job filtering (master getEffectiveErpResources).
 * Non-MES falls back to associated API resourceIds (master machine.erpResources).
 */
export const getEffectiveErpResources = createSelector(
  [getIsMESEnabled, getMachineSettings, getAssociatedErpResourceIds],
  (isMESEnabled, machineSettings, associatedErpResourceIds) => {
    if (isMESEnabled) {
      const ids = [...(machineSettings?.scheduleAs || [])];
      if (machineSettings?.laborResourceId) {
        ids.push(machineSettings.laborResourceId);
      }
      return [...new Set(ids)];
    }
    return associatedErpResourceIds;
  }
);
